module.exports = "/_next/static/images/feedback-5b0f2235f49d65cf53f0e46651bcfa53.svg";